var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isVisible)?_c('div',{staticClass:"closable-wrapper"},[_c('i',{staticClass:"closable-wrapper__icon icon icon-i16_close",on:{"click":function($event){_setup.isVisible = !_setup.isVisible}}}),_vm._v(" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }